import { Ikon } from '@studio/design-system/button';
import * as Callout from '@studio/design-system/callout';
import type { HtmlAttributes } from '@studio/design-system/props';
import { useLatestFn } from '@studio/react-utils/hooks';
import type { T_Nullable } from '@tryiris-ai/js-types';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { useGamepadIds, useHintPref } from '#~/gamepad/hooks.js';

/** `<Gamepad>` component. */
export const Gamepad = ({ className, ...props }: HtmlAttributes): T_Nullable<ReactElement> => {
  const gamepadIds = useGamepadIds();
  const [showHint, setShowHint] = useHintPref();

  const handleDismiss = useLatestFn(() => {
    setShowHint(false);
  });

  // Do we need to show the hint?
  if (!showHint || gamepadIds.length !== 0) {
    return null;
  }

  return null;

  return (
    <div className={twMerge('relative m-12 mb-0', className)} {...props}>
      <Callout.Root
        icon='joystick'
        title={<Callout.Title className='text-sm'>Connect Your Gamepad</Callout.Title>}
      >
        <Callout.P className='text-center'>
          Have a gamepad controller? Connect it now for joystick and camera control!
        </Callout.P>
      </Callout.Root>

      <Ikon className='absolute right-8 top-8 text-sm' icon='close' onClick={handleDismiss} />
    </div>
  );
};
